import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import TutorialVideo from "@/components/TutorialVideo";
import { Plus, Trash2 } from "lucide-react";

export default function AdminTutorialsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ key: "", title: "", description: "", video_url: "", thumbnail_url: "", category: "general", order: 0 });

  const load = async () => {
    const r = await api.get("/tutorials");
    setItems(r.data);
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/tutorials", form);
      toast.success("Saved");
      setForm({ key: "", title: "", description: "", video_url: "", thumbnail_url: "", category: "general", order: 0 });
      load();
    } catch (e) { toast.error("Failed"); }
  };

  const del = async (key) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/tutorials/${key}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-tutorials-page">
      <div className="kb-mono text-[10px] uppercase tracking-[0.2em] text-kb-ink-muted">TUTORIAL VIDEOS</div>
      <h1 className="font-serif text-3xl lg:text-4xl text-kb-ink mt-1">Curate <em className="italic text-kb-primary">tutorials & help videos</em></h1>
      <p className="text-sm text-kb-ink-muted mt-2 max-w-2xl">
        Add YouTube embed URLs or direct MP4 links. Placeholder thumbnails will be replaced when video URLs are set.
      </p>

      <form onSubmit={save} className="mt-8 kb-card p-6 grid sm:grid-cols-12 gap-3" data-testid="tutorial-form">
        <input className="kb-input sm:col-span-3 font-mono" placeholder="key (e.g. onboarding)" required
          value={form.key} onChange={(e) => setForm({ ...form, key: e.target.value })} data-testid="tutorial-key-input" />
        <input className="kb-input sm:col-span-5" placeholder="Title" required
          value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="tutorial-title-input" />
        <input className="kb-input sm:col-span-3" placeholder="Category" value={form.category}
          onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="tutorial-category-input" />
        <input type="number" className="kb-input sm:col-span-1" placeholder="Order" value={form.order}
          onChange={(e) => setForm({ ...form, order: (e.target.value === "" ? "" : (Number(e.target.value) || 0)) })} data-testid="tutorial-order-input" />
        <input className="kb-input sm:col-span-12" placeholder="Description" value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="tutorial-description-input" />
        <input className="kb-input sm:col-span-6" placeholder="Video URL (YouTube embed or .mp4)" value={form.video_url}
          onChange={(e) => setForm({ ...form, video_url: e.target.value })} data-testid="tutorial-video-input" />
        <input className="kb-input sm:col-span-5" placeholder="Thumbnail URL" value={form.thumbnail_url}
          onChange={(e) => setForm({ ...form, thumbnail_url: e.target.value })} data-testid="tutorial-thumbnail-input" />
        <button className="kb-btn-primary sm:col-span-1" type="submit" data-testid="tutorial-save-btn">
          <Plus className="w-4 h-4" />
        </button>
      </form>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((t) => (
          <div key={t.key} className="relative">
            <TutorialVideo tutorial={t} />
            <button onClick={() => del(t.key)} className="absolute top-2 right-2 bg-rose-600 text-white p-1.5 rounded-sm" data-testid={`tutorial-${t.key}-delete`}>
              <Trash2 className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
